import type { LanguageCodeForJSA } from '~/shared/internationalization';

import type { ProfileTask, ProfileTaskVersionInput } from '../model/profile-task';

export const createProfileTaskVersionInput = (
    task: ProfileTask,
    language: LanguageCodeForJSA,
): ProfileTaskVersionInput => ({
    classification: task.classification,
    classificationReasoning: task.classificationReasoning,
    description: task.description,
    effort: task.effort,
    effortReasoning: task.effortReasoning,
    language,
    requiredSkillIds: task.requiredSkills.map(({ skillId }) => skillId),
    title: task.title,
    workflowSteps: task.workflowSteps.map(({ description, title, workflowStepId }) => ({
        description,
        title,
        workflowStepId,
    })),
});
